import { SeoLinkRelEnum } from 'modules/seo-module/interfaces/seo-link-rel.enum';
import { LinkTarget } from 'atomic/link/link-target.enum';

export default function getLinkRelByTarget(target?: string): string | undefined {
    return target === LinkTarget.BLANK ? SeoLinkRelEnum.NOOPENER_NOREFERRER : void 0;
}
